<div class="bg">
    <div class="container-xl">
        <h2 class="display-4 text-center text-light">Select a meme format</h2>
        <div class="text-center m-3" *ngIf="formats.length == 0">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div class="img-slider d-block text-center" *ngIf="formats.length != 0">
            <button class="btn" id="prev" (click)="scrollLeft()">
                <svg class="bi bi-chevron-compact-left" width="3em" height="3em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M9.224 1.553a.5.5 0 0 1 .223.67L6.56 8l2.888 5.776a.5.5 0 1 1-.894.448l-3-6a.5.5 0 0 1 0-.448l3-6a.5.5 0 0 1 .67-.223z"/>
                </svg>
            </button>
            <!-- ---------Formats preview------------ -->
            <div class="flex-box"  id="forScroll">
                <div *ngFor="let format of formats">
                    <a class="mx-1" routerLink="/workspace"  [queryParams]="{ name: format.name }"><img class="thumbnail border border-dark rounded" src="assets/formats/{{format.name}}.png" alt="{{format.name}}" title={{format.name}}></a>
                </div>
            </div>
            <button class="btn" id="next" (click)="scrollRight();">
                <svg class="bi bi-chevron-compact-right" width="3em" height="3em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671z"/>
                </svg>
            </button>
        </div>
        <!-- ----------Partition------- -->
        <table>
            <tr>
                <td class="w-50"><hr class="border-dark"></td>
                <td class="display-4">OR</td>
                <td class="w-75"><hr class="border-dark"></td>
            </tr>
        </table>
        <!-- ----------------Uploading file div---------- -->
        <div>
            <h2 class="display-4 text-center text-light">Upload from your device</h2>
            <div class="d-block text-center">
                <form #uploadForm="ngForm">
                    <input (change)="SelectFile($event)" type="file" accept="image/*" name="fileToUpload" id="uploadBtn" hidden required>
                    <button class="btn border-dark" (click)="clickUpload()">
                        <svg class="bi bi-upload" width="3em" height="3em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M.5 8a.5.5 0 0 1 .5.5V12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8.5a.5.5 0 0 1 1 0V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8.5A.5.5 0 0 1 .5 8zM5 4.854a.5.5 0 0 0 .707 0L8 2.56l2.293 2.293A.5.5 0 1 0 11 4.146L8.354 1.5a.5.5 0 0 0-.708 0L5 4.146a.5.5 0 0 0 0 .708z"/>
                            <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0v-8A.5.5 0 0 1 8 2z"/>
                        </svg>
                    </button>
                    <!-- -----------File preview--------- -->
                    <div class="upload-div" *ngIf="isUploaded=='success'">
                        <img id="image-element" class="img-thumbnail" src="{{image | async}}" alt="Uploaded-image" onerror="this.src='assets/extras/loading.gif'">
                    </div>
                    <!-- -----------Upload progress------------ -->
                    <div class="d-inline" *ngIf="isUploaded=='process'">
                        <div class="spinner-border text-dark"></div>
                        <span class="lead text-dark">Uploading...</span>
                    </div>
                    <div class="d-inline" *ngIf="isUploaded=='fail'">
                        <span class="lead text-danger">Upload failed! Try again</span>
                    </div>
                    <div class="text-center mt-4">
                        <button (click)="setSrc()" routerLink="/workspace" [queryParams]="{ name: 'uploaded-img' }" class="btn btn-outline-light btn-lg" type="submit" [disabled]="isUploaded != 'success'">Continue</button>
                    </div>
                </form>
                <p class="lead text-dark">
                    *Don't worry! Your file will be deleted from our server as soon as you save your meme.
                </p>
            </div>
        </div>
    </div>  
</div>
<!-- -------------Credits------------------ -->
<div class="lead footer">
    Created By: <a href="https://www.linkedin.com/in/akshay-khandelwal-8a4094158/" target="_blank">Akshay Khandelwal</a>
</div>